import { render, staticRenderFns } from "./v-card.vue?vue&type=template&id=0a3a8a1f&scoped=true&"
import script from "./v-card.vue?vue&type=script&lang=js&"
export * from "./v-card.vue?vue&type=script&lang=js&"
import style0 from "./v-card.vue?vue&type=style&index=0&id=0a3a8a1f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3a8a1f",
  null
  
)

export default component.exports